import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@mui/material';

export default function CandidateProfileLayout({ open, onClose, children }) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: { backgroundColor: 'rgba(128, 128, 128, 0.4)' },
      }}
      slotProps={{
        backdrop: { invisible: false },
      }}
      PaperProps={{
        sx: {
          maxHeight: '100vh',
          width: '86vw',
          borderTopLeftRadius: 45,
          borderBottomLeftRadius: 45,
        },
      }}
    >
      {children}
    </Drawer>
  );
}

CandidateProfileLayout.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
